/* 孫吳傳・第 2 章：宛城（南陽郡，184 年）
 * 汝、潁的黃巾退守宛城。城是一個方形的夯土城，西南、東北各一座城門；城裡有民房，城中央是守將韓忠。
 * 朱儁的大營在西南，孫堅帶鄉里少年在東北的林子裡待命，朱儁擊鼓佯攻西南，孫堅趁機攻東北。 */
export const CITY = { x: 6000, y: 3000, hw: 1300, hh: 900 };
const T = 40, N = CITY.y - CITY.hh, S = CITY.y + CITY.hh, Wx = CITY.x - CITY.hw, E = CITY.x + CITY.hw;
export const GATES = { sw: [5000, S], ne: [7000, N] }; // 城門（牆上的缺口）
export const LADDER = [6300, N - 90]; // 架雲梯的地方：北牆外
const seg = (a, b, y) => [(a + b) / 2, y, (b - a) / 2, T]; // 橫的一段牆
export default {
  id: 'wan', name: '宛城', W: 9200, H: 6000, seed: 1842,
  bases: [[1600, 5000], [8100, 900]], // 朱儁大營、孫堅待命處（東北）
  walls: [
    seg(Wx, GATES.ne[0] - 110, N), seg(GATES.ne[0] + 110, E, N), // 北牆（東段有城門）
    seg(Wx, GATES.sw[0] - 110, S), seg(GATES.sw[0] + 110, E, S), // 南牆（西段有城門）
    [Wx, CITY.y, T, CITY.hh + T], [E, CITY.y, T, CITY.hh + T], // 西牆、東牆
  ],
  roads: [
    { pts: [[1600, 5000], [3000, 4700], [4300, 4300], [GATES.sw[0], S + 200], [GATES.sw[0], S - 200], [CITY.x, CITY.y]], w: 150 }, // 西南：朱儁大營 → 西南門 → 城中
    { pts: [[8100, 900], [7600, 1300], [GATES.ne[0], N - 300], [GATES.ne[0], N + 200], [CITY.x + 300, CITY.y - 300], [CITY.x, CITY.y]], w: 130 }, // 東北：待命處 → 東北門 → 城中
    { pts: [[7600, 1300], [6700, 1700], [5600, 1750], [4300, 2000]], w: 100 }, // 北牆外的小路
  ],
  rocks: [[2600, 1400, 520, 260], [8600, 4600, 460, 240], [3400, 3000, 300, 180], [8700, 2600, 220, 160]],
  woods: 0.45,
  sight: 0.7,
  clearings: [[CITY.x, CITY.y, 1500], [LADDER[0], LADDER[1] - 200, 380], [7300, 1500, 500]],
  fields: [[2800, 3900, 640, 300], [3800, 5300, 560, 280, '#86803f']],
  villages: [{ x: CITY.x, y: CITY.y, n: 16, r: 850 }],
  tents: [{ x: 1600, y: 5000, n: 10, r: 460, chief: true, col: '#b8433a', flag: '朱' }, { x: 8100, y: 900, n: 4, r: 300, col: '#b8433a' }],
  marsh: [[4000, 1500, 320, 140]],
  grass: [[7700, 1700, 280, 120], [6800, 1500, 260, 110], [5600, 1500, 240, 110], [8400, 1600, 220, 100]],
};
